import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { handbookResourceType } from "./handbookResourceConsts";

export const handbookIdentifierStruct = createIdentifierStruct(
  handbookResourceType
);
